// extracted by mini-css-extract-plugin
module.exports = {"button":"ToggleAudio_button__mPt0a"};